
export default item => ({
  isSelected: false,
  ...item
})